import { Component, Input, OnInit } from '@angular/core';
import { EthWalletService } from 'src/app/services/eth-wallet.service';

@Component({
  selector: 'app-pool-funds',
  templateUrl: './pool-funds.component.html',
  styleUrls: ['./pool-funds.component.scss']
})
export class PoolFundsComponent implements OnInit {
  @Input() records: any[] = [];
  @Input() showAccount = false;

  constructor(public ethWalletService: EthWalletService) {}

  ngOnInit(): void {
  }

}
